import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.ul`
  line-height: 175%;
  font-size: 1.1rem;
  margin: 1.25rem 0;
  padding-left: 1.25rem;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

export default class UnorderedList extends Component {
  render() {
    const { children } = this.props
    
    return (
      <Box>
        {children}
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnorderedList/UnorderedList.js